import React, { useEffect, useState } from "react";
import { Button, TextField, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle, Box, MenuItem, FormControlLabel, Switch } from '@material-ui/core';
import { ExtFixture, ExtFixtureMapping, ExtFixtureParticipant, FixtureNg, MapFixtureNgToFixtureRequest } from "./FixtureOverviewModels";
import { Fixture } from "../TeamOverview/TeamOverviewModels";
import { League } from "../LeagueOverview/LeagueModels";
import CreateRoundUtil from "../CreateRound/CreateRoundUtil";
import FixtureOverviewUtil from "./FixtureOverviewUtil";
import RoundOverviewUtil from "../RoundOverview/RoundOverviewUtil";
import LeagueUtil from "../LeagueOverview/LeagueUtil";

interface MapFixtureToFixtureNgDialogProps {
    open: boolean;
    fixture?: Fixture;
    league?: League;
    fixtureNg: FixtureNg;
    timestamp: number;
    onClose: (fixtureNg: FixtureNg | undefined) => void;
}
interface MapFixtureToFixtureNgDialogState {
    timestamp: number;
    fixtureNg: FixtureNg;
    fixtureNgTitle: string;
    fixtureNgSubtitle: string;
    fixtureId: number;
    fixtureName: string;
    fixtureTitle: string;
    fixtureSubtitle: string;
    reversed: boolean;
    mustConfirm: boolean;
    mustConfirms: string[];
    confirmed: boolean;
    valid: boolean;
    fixtureNgError: string;
    fixtureError: string;
    confirmedError: string;
    update?: MapFixtureNgToFixtureRequest;
}

function checkState(state : MapFixtureToFixtureNgDialogState) {
    var fixtureNg = state.fixtureNg;
    var valid = true;
    var fixtureNgErr = "";
    var fixtureErr = "";
    var confirmedErr = "";

    if (fixtureNg.fixtureId && fixtureNg.fixtureId > 0) {
        valid = false;
        fixtureNgErr = "FixtureNg is alread mapped";
    }
    if (state.fixtureId <= 0) {
        valid = false;
        fixtureErr = "Fixture not specified";
    }

    if (state.mustConfirm && !state.confirmed) {
        valid = false;
        confirmedErr = "Confirmation mandatory";
    }

    state.valid = valid;
    state.fixtureNgError = fixtureNgErr;
    state.fixtureError = fixtureErr;
    state.confirmedError = confirmedErr;

    if (valid) {
        // var homeParticipant = fixtureNg.homeParticipant;
        // var awayParticipant = fixtureNg.awayParticipant;
        var mapRequest : MapFixtureNgToFixtureRequest = {
            fixtureNgId: state.fixtureNg.id,
            fixtureId: state.fixtureId
        };
        state.update = mapRequest;

    } else {
        state.update = undefined;
    }
}

function getFixtureTitle(id: number | string, name: string, startingAt: Date, status: string, league: string) : string {
    var title = `Id: ${id} | Name: ${name} | Starting at: ${CreateRoundUtil.toGameDateString(startingAt)} | Status: ${status} | League: ${league}`;
    return title;
}
function getFixtureSubtitle(id: number | string, startingAt: Date, status: string, league: string) : string {
    //var title = `Id: ${id} | Starting at: ${CreateRoundUtil.toGameDateString(startingAt)} | Status: ${status} | League: ${league}`;
    var title = `${id} | ${CreateRoundUtil.toGameDateString(startingAt)} | ${league} | ${status}`;
    return title;
}
const MapFixtureToFixtureNgDialog: React.FC<MapFixtureToFixtureNgDialogProps> = (props) => {
    const getDefaultFormState = () : MapFixtureToFixtureNgDialogState => {
        var fixture = props.fixture;
        var fixtureNg = props.fixtureNg;
        var competitionTitle = "";
        var competitionNg = fixtureNg.competition;
        if (competitionNg) {
            competitionTitle = `${competitionNg.sportName}/${competitionNg.name} (${competitionNg.countryName})`;
        }
        var fixtureNgTitle = getFixtureTitle(fixtureNg.id.toString(), fixtureNg.name, fixtureNg.startingAt, "", competitionTitle);
        var fixtureNgSubtitle = getFixtureSubtitle(fixtureNg.id.toString(), fixtureNg.startingAt, "", competitionTitle);
        var mapping = fixtureNg.fixture;
        var fixtureId = 0;
        var fixtureName = "";
        var fixtureTitle = "";
        var fixtureSubtitle = "";
        var mustConfirm = false;
        var mustConfirms : string[] = [];
        //var reversed = mapping ? mapping.reversed : false;
        var reversed = false;
        if (fixture) {
            fixtureId = fixture.id;
            fixtureName = fixture.name;
            fixtureTitle = getFixtureTitle(fixture.id, fixture.name, fixture.startingAt, fixture.status, fixture.leagueName);
            fixtureSubtitle = getFixtureSubtitle(fixture.id, fixture.startingAt, fixture.status, fixture.leagueName);
            if (mapping) {
                if (fixtureId !== mapping.id) {
                    mustConfirms.push("Fixture-Mapping id diff");
                    var diffMsecs = Math.abs(new Date(fixture.startingAt).getTime() - new Date(fixtureNg.startingAt).getTime());
                    var diffMinutes = Math.floor(diffMsecs / 1000 / 60);
                    if (diffMinutes > 60) {
                        mustConfirms.push(`Starting at diff exceeds 60 minutes [diff: ${diffMinutes}]`);
                    }
                }
            }
        } else if (mapping) {
            fixtureId = mapping.id;
            fixtureName = mapping.name;
            fixtureTitle = getFixtureTitle(mapping.id, mapping.name, mapping.startingAt, mapping.status, mapping.leagueName);
            fixtureSubtitle = getFixtureSubtitle(mapping.id, mapping.startingAt, mapping.status, mapping.leagueName);
        }

        if (reversed) {
            mustConfirms.push("Reversed");
        }

        var fs : MapFixtureToFixtureNgDialogState = {
            timestamp: props.timestamp,
            fixtureNg: props.fixtureNg,
            fixtureNgTitle: fixtureNgTitle,
            fixtureNgSubtitle: fixtureNgSubtitle,
            fixtureId: fixtureId,
            fixtureName: fixtureName,
            fixtureTitle: fixtureTitle,
            fixtureSubtitle: fixtureSubtitle,
            reversed: reversed,
            mustConfirm: (mustConfirms.length > 0),
            mustConfirms: mustConfirms,
            confirmed: false,
            valid: false,
            fixtureNgError: "",
            fixtureError: "",
            confirmedError: ""
        };
        checkState(fs);
        return fs;
    }
    
    const [open, setOpen] = useState<boolean>(props.open);
    const [formState, setFormState] = useState<MapFixtureToFixtureNgDialogState>({
        timestamp: props.timestamp,
        fixtureNg: props.fixtureNg,
        fixtureNgTitle: "",
        fixtureNgSubtitle: "",
        fixtureId: 0,
        fixtureName: "",
        fixtureTitle: "",
        fixtureSubtitle: "",
        reversed: false,
        mustConfirm: false,
        mustConfirms: [],
        confirmed: false,
        valid: false,
        fixtureNgError: "",
        fixtureError: "",
        confirmedError: ""
    }
    );
    const [fixtureNg, setFixtureNg] = useState<FixtureNg>(props.fixtureNg);
    const [saveError, setSaveError] = useState<string>("");
    const [saveStatus, setSaveStatus] = useState<number>(0);

    var propsFixtureId = props.fixture ? props.fixture.id : 0;
    var propsFixtureNgId = props.fixtureNg.id;
    useEffect(() => {
        setFormState(getDefaultFormState());
    }, [props.timestamp, propsFixtureId, propsFixtureNgId]);

    const handleClickOpen = () => {
        setOpen(true);
        setFormState(getDefaultFormState());
    };

    const handleDialogClick = (e: React.MouseEvent<HTMLDivElement, MouseEvent>) : void => {
        e.stopPropagation();
    }; 

    const handleClose = () => {
        setOpen(false);
        if (props.onClose) {
            props.onClose(undefined);
        }
    };
    const handleChange = (name: string, value:string) =>{
        var fs = {...formState, [name]: value};
        checkState(fs);
        setFormState(fs);
    }
    const onConfirmedChanged = () => {
        var confirmed = !formState.confirmed;
        var fs = {...formState, confirmed: confirmed}
        checkState(fs);
        setFormState(fs);
    }
    const onSave = () => {
        const METHOD_NAME = "MapFixtureToFixtureNg";

        setSaveError("");
        setSaveStatus(0);
        if (!formState.valid) {
            setSaveError("Input is not valid");
            return;
        }
        if (!formState.update) {
            setSaveError("No changes");
            return;
        }
        setSaveStatus(1);
        var saveJson = JSON.stringify(formState.update);
        FixtureOverviewUtil.mapFixtureNgFixture(formState.update).then(resp => {
            setSaveStatus(0);
            if (resp.success){
                var fixtureNg = resp.item;
                if (fixtureNg) {
                    setOpen(false);
                    if (props.onClose) {
                        props.onClose(fixtureNg);
                    }
                    return;
                } 
                setSaveError(`${METHOD_NAME} failure: FixtureNg was not returned.`);

            } else {
                setSaveError(resp.message);
            }
        }).catch(error => {
            setSaveError(`${METHOD_NAME} error: ${error}`);
            setSaveStatus(0);
        });           
    };
    var saveEnabled = (formState.valid && saveStatus === 0 && formState.update);
    var saveErrorBox = null;
    if (saveError.length > 0) {
        saveErrorBox = (<Box color="red">{saveError}</Box>);
    }

    var mustConfirmBox = null;
    if (formState.mustConfirm) {
        mustConfirmBox = (
            <Box>
                <ul style={{ color: RoundOverviewUtil.INVALID_COLOR }}>
                    {formState.mustConfirms.map((msg, index) => (
                        <li>{msg}</li>
                    ))}
                </ul>
                <FormControlLabel control={<Switch
                        checked={formState.confirmed}
                        onChange={(e: any) => onConfirmedChanged()}
                        inputProps={{ 'aria-label': 'controlled' }}
                    />}
                    label="Confirmed"                   
                />
            </Box>

        );
    }
    return (
        <div>
            {props.open ? null : (
                <Button onClick={handleClickOpen} variant="outlined" color="secondary" size="small">
                    Map fixture to FixtureNg
                </Button>
            )}
        <Dialog
            open={open}
            onClose={handleClose}
            onClick={e => handleDialogClick(e)}
            aria-labelledby="form-dialog-title"
        >
            <DialogTitle id="form-dialog-title">Map Fixture to FixtureNg</DialogTitle>
            <DialogContent dividers>
                {/* <DialogContentText>
                    To subscribe to this website, please enter your email address here. We will send updates
                    occasionally.
                </DialogContentText> */}
                <Box display="flex" alignItems="center">
                    <TextField
                        label="Fixture"
                        name="fixtureTitle"
                        value={formState.fixtureName}
                        helperText={formState.fixtureError ? formState.fixtureError : formState.fixtureSubtitle}
                        error={(formState.fixtureError.length > 0)}
                        style={{width:600}}
                        InputProps={{
                        readOnly: true,
                        }}
                    />
                </Box>
                <Box display="flex" alignItems="center">
                    <TextField
                        label="FixtureNg"
                        name="fixtureNgTitle"
                        value={formState.fixtureNg.name}
                        helperText={formState.fixtureNgError ? formState.fixtureNgError : formState.fixtureNgSubtitle}
                        error={(formState.fixtureNgError.length > 0)}
                        style={{width:600}}
                        InputProps={{
                        readOnly: true,
                        }}
                    />
                </Box>
                {mustConfirmBox}
                {saveErrorBox} 
                {/* <Box>
                    FormState:<br></br>
                    <pre>{JSON.stringify(formState, undefined, 2)}</pre>
                </Box> */}
            </DialogContent>
            <DialogActions>
                <Button onClick={handleClose} color="primary">
                    Cancel
                </Button>
                <Button onClick={onSave} color="primary" disabled={!saveEnabled}>
                    Save
                </Button>
            </DialogActions>
        </Dialog>
        </div>
    );
};

export default MapFixtureToFixtureNgDialog;
